import * as React from 'react';
import Checkbox from '~/UI/Checkbox/Checkbox';

import * as styles from './styles.less';

export const CheckboxRow: React.FunctionComponent<
	React.PropsWithChildren<{
		disabled: boolean;
		checked: boolean;
		onChange(checked: boolean): void;
	}>
> = ({ disabled, checked, children, onChange }) => {
	return (
		<div className={styles.label}>
			<Checkbox checked={checked} disabled={disabled} onChange={onChange}>
				{children}
			</Checkbox>
		</div>
	);
};

CheckboxRow.displayName = 'UserSettings.CheckboxRow';
